import { FULL_SCREEN_MODE, WINDOWED_MODE } from '@/vuex/types'

const isFullScreenMode = (state) => {
  return state.currentSlideMode === FULL_SCREEN_MODE
}

const isWindowedMode = (state) => {
  return state.currentSlideMode === WINDOWED_MODE
}

const isPresenting = (_state, getters) => {
  return (getters.isWindowedMode || getters.isFullScreenMode) && _state.route.name !== 'PresentationBackstage'
}

const isBackstage = (state) => {
  return state.route && state.route.name === 'PresentationBackstage'
}

const presentationHasNotes = (state) => {
  return state.presentation &&
    state.presentation.slides &&
    state.presentation.slides.some((slide) => slide.notes)
}

export default {
  isFullScreenMode,
  isWindowedMode,
  isPresenting,
  isBackstage,
  presentationHasNotes,
}
